<template>
    <div class="window-edit">
        <div class="window">
            <div class="close-window" @click="close"><img src="../assets/img/close-window.svg"></div>

            <div class="title">Редактировать адрес</div>
            <div class="window-content">
                <div class="window-tab">
                    <div class="tab-item green" :class="tabs.id == 0 ? 'active' : ''" @click="setTab(0)">Данные</div>
                    <div class="tab-item" :class="tabs.id == 1 ? 'active' : ''" @click="setTab(1)">Карта</div>
                </div>
                <div class="content-form" v-if="(isMobile() && tabs.id == 0) || !isMobile()">
                    <div class="input-block" style="margin-bottom: 22px;">
                        <div class="label">Адрес</div>
                        <div class="input icon">
                            <img src="../assets/img/search-gold.svg">
                            <input type="text" 
                                v-model="form.address" 
                                
                                @input="searchSuggest"
                                placeholder="Введите адрес"
                            >
                        </div>

                        <div class="address-suggest" v-if="suggestList">
                            <div class="close-suggest" @click="suggestList = null"><img src="../assets/img/close-window.svg"></div>
                            <div class="item-suggest" 
                                v-for="suggest in suggestList"
                                @click="setAddress(suggest)"
                                :key="suggest"
                            >{{ suggest.unrestricted_value }}</div>
                        </div>
                    </div>

                    <div class="input-block">
                        <div class="label">Полный адрес</div>
                        <div class="input">
                            <input type="text" v-model="form.country" spellcheck="false" placeholder="Страна">
                        </div>
                    </div>

                    <div class="input-group">
                        <input type="text" v-model="form.region" spellcheck="false" placeholder="Облать">
                        <input type="text" v-model="form.city" spellcheck="false" placeholder="Город / Поселение">
                    </div>

                    <div class="input-group">
                        <input type="text" v-model="form.index" spellcheck="false" placeholder="Индекс">
                        <input type="text" v-model="form.street" spellcheck="false" placeholder="Улица">
                        <input type="text" v-model="form.building" spellcheck="false" placeholder="Номер дома">
                    </div>

                    <div class="input-group">
                        <input type="text" v-model="form.coords" @input="setHandCoords" placeholder="Координаты">
                        <input type="text" v-model="form.statusAddress" disabled placeholder="Статус адреса">
                    </div>

                    <div class="input-group" style="margin-top: 20px;">
                        <input type="text" v-model="form.label" spellcheck="false" placeholder="Название точки">
                        <input type="text" v-model="form.agent" spellcheck="false" placeholder="ООО / ИП Иванов И.И.">
                    </div>

                    <div class="input-block">
                        <div class="input icon">
                            <img src="../assets/img/phone-input.svg">
                            <input type="text" v-model="form.phone" id="phone" spellcheck="false" placeholder="Номер телефона">
                        </div>
                    </div>

                    <div class="input-block">
                        <div class="input icon">
                            <img src="../assets/img/pen-input.svg">
                            <input type="text" v-model="form.comment" spellcheck="false" placeholder="Комментарий к точке продаж">
                        </div>
                    </div>

                    <div class="input-block">
                        <div class="input icon">
                            <img src="../assets/img/pen-input.svg">
                            <input type="text" v-model="form.notes" spellcheck="false" placeholder="Заметки">
                        </div>
                    </div>

                    <div class="input-group">
                        <input type="text" v-model="form.company" spellcheck="false" placeholder="Дистрибьютор">
                        <input type="text" v-model="form.division" spellcheck="false" placeholder="Дивизион">
                        <input type="text" v-model="form.code" spellcheck="false" placeholder="Код адреса">
                    </div>

                    <div class="status-block">
                        <div class="status-item green" :class="form.status_id == 0 ? 'active' : ''" @click="setStatus(0)">Впорядке</div>
                        <div class="status-item blue" :class="form.status_id == 1 ? 'active' : ''" @click="setStatus(1)">Уточнить</div>
                        <div class="status-item red" :class="form.status_id == 2 ? 'active' : ''" @click="setStatus(2)">Ошибка</div>
                        <div class="status-item gray" :class="form.status_id == 3 ? 'active' : ''" @click="setStatus(3)">Отключен</div>
                    </div>

                    <div class="meta">
                        <span><img src="../assets/img/user.svg">{{ form.userEmail }}</span>
                        <span><img src="../assets/img/clock.svg">{{ created_date }}</span>
                    </div>
                    <div >
                        <div class="check"><label><input type="checkbox" value="0" v-model="form.plonq"><span>plonq500</span></label></div>
                        <div class="check"><label><input type="checkbox" value="1" v-model="form.plonq"><span>plonqX</span></label></div>
                        <div class="check"><label><input type="checkbox" value="2" v-model="form.plonq"><span>plonqA</span></label></div>
                    </div>
                    <div class="btn-group">

                        <div class="check"><label><input type="checkbox" value="0" v-model="form.sobirator"><span>Собиратор</span></label></div>
                        <div class="btn-group-remove">
                            <a href="#remove" class="btn-remove" @click="removeAddressConfirm"><img src="../assets/img/close-red.svg">Удалить</a>
                        </div>
                        
                        <a href="#cancel" @click="close" class="btn-cancel">Отмена</a>
                        <a href="#save" class="btn-save" @click="updateAddress"><img src="../assets/img/check-white.svg">Сохранить</a>
                    </div>
                </div>
                <div class="content-map" v-if="(isMobile() && tabs.id == 1) || !isMobile()">
                    <div class="label-text">Уточнить местоположение адреса</div>
                    <div class="map">
                        <div class="map-content" id="map-content"></div>
                        <div class="map-label">
                            <div class="label-top">Yandex.MAPS</div>
                            <div class="label-bottom">2GIS</div>
                        </div>
                        <div class="map-gis" id="map-gis">
                            <div class="gis-bg"></div>
                            <div class="gis-content" id="gis-content" style="width: 100%; height: 100%;"></div>
                        </div>
                        <div class="map-close" v-if="!form.address && !form.coords">
                            <div class="close-content">
                                <img src="../assets/img/pin-gold.svg">
                                <span>Для уточнения<br>заполните адрес</span>
                            </div>
                        </div>
                        <img src="../assets/img/map.png" class="img-close" v-if="!form.address && !form.coords">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useStore } from "vuex"
import { computed, ref, reactive, toRaw, watchEffect, onBeforeMount} from "vue"
import axios from 'axios'

import { debounce } from 'debounce'

import Swal from 'sweetalert2'

export default {
    name: 'windowEdit',
    setup() {
        const store = useStore();
        const close = () => {
            store.state.windowEditStatus = false
        }

        function initMap (selectCoords) {
            var map = new ymaps.Map('map-content', {
                    center: selectCoords,
                    zoom: 17,
                    controls: []
                })

            var myPlacemark = new ymaps.Placemark(selectCoords, null, {
                preset: 'islands#blueDotIcon',
                draggable: true
            });

            /* Событие dragend - получение нового адреса */
            myPlacemark.events.add('dragend', function(e){
                var coord = e.get('target').geometry.getCoordinates();
                form.coords = coord.join(' ')
                
                document.querySelector('#map-gis').innerHTML = `<div class="gis-bg"></div>
                <div class="gis-content" id="gis-content" style="width: 100%; height: 100%;"></div>`
                initGis(coord);
            });
		

            map.geoObjects.add(myPlacemark)
        }

        function initGis (selectCoords) {
            DG.then(function() {
                var map = DG.map('gis-content', {
                    center: selectCoords,
                    zoom: 17,
                    fullscreenControl: false,
                    zoomControl: false
                });

                DG.marker(selectCoords).addTo(map)
            });
        }

        const suggestList = ref(null)
        const ddSearch = (value) => {
            var url = "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address";
            var token = "dede3dda912a4a8174625e9df8d6b41066439061";
            var query = {"query": value, "locations": [{"country": "*"}]}

            var config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": "Token " + token
                }
            }

            axios.post(url, query, config)
            .then((response) => {
                let data = response.data
                
                if (data.suggestions) {
                    suggestList.value = data.suggestions
                }
            })
        }

        const searchSuggest = debounce(function (e) {
            if(e.target.value.length > 0) {
                ddSearch(e.target.value)
            } else {
                suggestList.value = null
            }
        }, 500)

        const tabs = reactive({
            id: 0
        })
    
        const setTab = (tab_id) => {
            tabs.id = tab_id
            
            setTimeout(() => {
                if (tab_id == 1) {
                    document.querySelector('#map-content').innerHTML = ''
                    document.querySelector('#map-gis').innerHTML = `<div class="gis-bg"></div>
                <div class="gis-content" id="gis-content" style="width: 100%; height: 100%;"></div>`
                    ymaps.ready(initMap(form.coords.split(' ')));
                    initGis(form.coords.split(' '));
                }
            }, 50)
        }

        const isMobile = () => {
            if (window.innerWidth < 979)
                return true
        }

        const form = reactive({
            _id: null,
            address: null,
            index: null,
            country: null,
            region: null,
            city: null,
            street: null,
            building: null,
            coords: null,
            statusAddress: null,
            status_id: null,
            fias_id: null,
            kladr_id: null,
            label: null,
            agent: null,
            phone: null,
            plonq: [0],
            comment: null,
            notes: null,
            code: null,
            division: null,
            company: null,
            sobirator: null,
            userEmail: null
        })

        const created_at = ref(null)
        const created_date = computed(() => {
            return new Date(created_at.value).toLocaleString('ru').split(',')[0]
        })

        const setStatus = (status_id) => {
            form.status_id = status_id
        }

        const showMessageStatus = (message, status, timeout) => {
            store.state.notifyMessage = message
            store.state.isNotifyMessageError = status 

            setTimeout(() => {
                store.state.notifyMessage = null
                store.state.isNotifyMessageError = false
            }, timeout)
        }

        const updateAddress = () => {
            if (form.userEmail === form.editEmail) {
            // form.sobirator = form.sobirator == 1 ? true : false
                // if(form.sobirator === "true")
                //     form.sobirator = true
                // if(form.sobirator === "1")
                //     form.sobirator = true
                // if(form.sobirator === "0")
                //     form.sobirator = null
            axios.put(process.env.VUE_APP_SERVER + '/api/address/' + form._id, toRaw(form)).then((response) => {

                console.log('update address axios')
                close()
                showMessageStatus('Адрес обновлен', false, 2000);
            })  
            }else{

            if(store.state.accessType === "1"){
            // form.sobirator = form.sobirator == 1 ? true : false
                if(form.sobirator === "true")
                    form.sobirator = true
                if(form.sobirator === "1")
                    form.sobirator = true
                if(form.sobirator === "0")
                    form.sobirator = null
            axios.put(process.env.VUE_APP_SERVER + '/api/address/' + form._id, toRaw(form)).then((response) => {
                console.log('update address axios')

                close()
                showMessageStatus('Адрес обновлен', false, 2000);
            })  
            }else{
                showMessageStatus('Вы не можете редактировать чужие адреса', false, 2000);
            }
            }
        }

        const removeAddress = () => {
            axios.delete(process.env.VUE_APP_SERVER + '/api/address/' + form._id, toRaw(form)).then((response) => {
                close()

                store.dispatch('getAddress')
            })
        }

        const setAddress = (suggest) => {
            suggestList.value = null
            suggest.data.block = suggest.data.block ? ' к ' + suggest.data.block : ''
            let building = 'д ' + suggest.data.house + suggest.data.block
            let statusAddress = (status) => {
                /*
                    0 — точные координаты
                    1 — ближайший дом
                    2 — улица
                    3 — населенный пункт
                    4 — город
                    5 — координаты не определены
                */
                let statusResult = null
                switch (status) {
                    case "0": statusResult = 'Точные координаты'; break;
                    case "1": statusResult = 'Ближайший дом'; break;
                    case "2": statusResult = 'Улица'; break;
                    case "3": statusResult = 'Населенный пункт'; break;
                    case "4": statusResult = 'Город'; break;
                    case "5": statusResult = 'Координаты не определены'; break;
                }

                return statusResult
            }

            form.address = suggest.unrestricted_value
            form.country = suggest.data.country
            form.region = suggest.data.region
            form.city = suggest.data.city ? suggest.data.city : suggest.data.settlement
            form.street = suggest.data.street
            form.building = building
            form.index = suggest.data.postal_code
            form.coords = suggest.data.geo_lat + ' ' + suggest.data.geo_lon
            form.statusAddress = statusAddress(suggest.data.qc_geo)
            form.fias_id = suggest.data.fias_code
            form.kladr_id = suggest.data.kladr_id
            form.plonq = suggest

            const selectCoords = [suggest.data.geo_lat, suggest.data.geo_lon]

            document.querySelector('#map-content').innerHTML = ''
            document.querySelector('#map-gis').innerHTML = `<div class="gis-bg"></div>
                <div class="gis-content" id="gis-content" style="width: 100%; height: 100%;"></div>`
            ymaps.ready(initMap(selectCoords));
            initGis(selectCoords);
        }

        const removeAddressConfirm = () => {
            Swal.fire({
                title: 'Удаляем адрес?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                cancelButtonText: 'Отмена',
                confirmButtonText: 'Да, удалить'
                }).then((result) => {
                if (result.isConfirmed) {
                    removeAddress()

                    Swal.fire(
                    'Адрес удален',
                    '',
                    'success'
                    )
                }
            })
        }

        const setHandCoords = () => {
            form.coords = form.coords.replace(',', '')

            document.querySelector('#map-content').innerHTML = ''
            document.querySelector('#map-gis').innerHTML = `<div class="gis-bg"></div>
        <div class="gis-content" id="gis-content" style="width: 100%; height: 100%;"></div>`
            ymaps.ready(initMap(form.coords.split(' ')));
            initGis(form.coords.split(' '));
        }

        watchEffect(() => {
            if (store.state.editAddressData != null) {
                let data = store.state.editAddressData
                form._id = data.response._id
                form.address = data.response.address
                form.country = data.response.country
                form.region = data.response.region
                form.city = data.response.city
                form.street = data.response.street
                form.building = data.response.building
                form.index = data.response.index
                form.coords = data.response.coords
                form.statusAddress = data.response.statusAddress
                form.fias_id = data.response.fias_id
                form.kladr_id = data.response.kladr_id
                form.code = data.response.code
                form.division = data.response.division
                form.company = data.response.company
                form.label = data.response.label
                form.agent = data.response.agent
                form.phone = data.response.phone
                form.plonq = data.response.plonq 
                form.comment = data.response.comment
                form.notes = data.response.notes
                form.status_id = data.response.status_id
                form.userEmail = data.response.userEmail
                form.editEmail = store.state.userEmail
                form.sobirator = data.response.sobirator == "1" ? true : false || data.response.sobirator == "true" ? true:false
                created_at.value = data.response.created_at
                console.log(form)
                if (!isMobile()) {
                    setTimeout(function () {
                        document.querySelector('#map-content').innerHTML = ''
                        document.querySelector('#map-gis').innerHTML = `<div class="gis-bg"></div>
                    <div class="gis-content" id="gis-content" style="width: 100%; height: 100%;"></div>`
                        ymaps.ready(initMap(data.response.coords.split(' ')));
                        initGis(data.response.coords.split(' '));

                        //let maskElement = document.querySelector('#phone')
                        //let mask = IMask(maskElement, {mask: '+{7}(000)-000-00-00'})
                    }, 500)
                }
            }
        })

        return {
            close,
            form,
            created_at,
            created_date,
            updateAddress,
            ddSearch,
            suggestList,
            setAddress,
            searchSuggest,
            removeAddressConfirm,
            setStatus,
            setHandCoords,
            tabs,
            setTab,
            isMobile
        }
    }
}
</script>
<style scoped>
 .form-check input[type="checkbox"]:checked, 
.form-check input[type="checkbox"]:not(:checked)
{
    position: absolute;
    left: -9999px;
}

.form-check input[type="checkbox"]:checked + label, 
.form-check input[type="checkbox"]:not(:checked) + label{
    display: inline-block;
    position: relative;
    padding-left: 28px;
    line-height: 20px;
    cursor: pointer;
}

.form-check input[type="checkbox"]:checked + label:before, 
.form-check input[type="checkbox"]:not(:checked) + label:before{
    content: "";
    position: absolute;
    left: 0px;
    top: 0px;
    width: 18px;
    height: 18px;
    border: 1px solid #dddddd;
    background-color: #ffffff;
}

.form-check input[type="checkbox"]:checked + label:before, 
.form-check input[type="checkbox"]:not(:checked) + label:before {
    border-radius: 2px;
}


.form-check input[type="checkbox"]:checked + label:after, 
.form-check input[type="checkbox"]:not(:checked) + label:after {
    content: "";
    position: absolute;
    -webkit-transition: all 0.2s ease;
    -moz-transition: all 0.2s ease;
    -o-transition: all 0.2s ease;
    transition: all 0.2s ease;
}

.form-check input[type="checkbox"]:checked + label:after, 
.form-check input[type="checkbox"]:not(:checked) + label:after {
    left: 3px;
    top: 4px;
    width: 10px;
    height: 5px;
    border-radius: 1px;
    border-left: 4px solid #e145a3;
    border-bottom: 4px solid #e145a3;
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
}


.form-check input[type="checkbox"]:not(:checked) + label:after {
    opacity: 0;
}

.form-check input[type="checkbox"]:checked + label:after {
    opacity: 1;
} 
</style>